"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StageMicIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var themes_1 = require("../../themes");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill1, fill1 = _b === void 0 ? themes_1.THEME.colors.basic.White100 : _b, _c = _a.fill2, fill2 = _c === void 0 ? 'transparent' : _c, size = _a.size, rest = __rest(_a, ["fill1", "fill2", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 25" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M3.21152 7.898C2.77055 7.51856 2.7453 6.84424 3.15666 6.43288L6.43239 3.15715C6.84375 2.74579 7.51807 2.77104 7.89751 3.21201L21.3893 18.8917C21.7306 19.2883 21.7084 19.881 21.3384 20.251L20.2505 21.3389C19.8805 21.7089 19.2878 21.7311 18.8912 21.3898L3.21152 7.898Z", fill: fill2, stroke: "black" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "6.39451", cy: "6.39493", r: "5.65684", transform: "rotate(-45 6.39451 6.39493)", fill: fill1, stroke: "black" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M1.59375 9.59488V9.59488C5.18861 8.05422 8.05307 5.18976 9.59373 1.5949V1.5949", stroke: "black" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M3.19531 11.195V11.195C6.79017 9.65432 9.65464 6.78986 11.1953 3.195V3.195", stroke: "black" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "21.1923", cy: "21.1921", r: "0.848526", fill: "black" }, void 0)] }), void 0));
};
var StageMicIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.StageMicIcon = StageMicIcon;
//# sourceMappingURL=StageMicIcon.js.map